<template>
    <RewardLayout
        :headerText="headerText"
        :showSearch="true"
        :pageName="pageName"
        :modalController="modalController"
        :isAccountLoaded="isAccountLoaded"
        @clickBack="clickBack()">
        <template v-slot:content>
            <RewardCategoryList
                v-if="isLoaded"
                :isAmbassadorCategory="isAmbassadorCategory"
                :category="mainCategory"
                :categoryList="categoryList"
                :trackingService="trackingService" />
        </template>
    </RewardLayout>
</template>
<script>
// helper
import Util from '@/helper/Utility.js';
// mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import RewardMixin from '../mixin/RewardMixin';
// component
import RewardLayout from '../component/share/RewardLayout.vue';
import RewardCategoryList from "../component/Category/RewardCategoryList.vue";
export default {
    name: 'RewardCategory',
    mixins: [AccountMixin, ErrorApiMixin, RewardMixin],
    components: {
        RewardLayout,
        RewardCategoryList,
    },
    date: function () {
        return {
            isActive: false,
            isLoaded: false
        };
    },
    created: function () {
        Util.scrollTop();
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);
    },
    activated: function () {
        if (!this.isActive) return;

        this.isLoaded = false;
        this.initCategory();
    },
    methods: {
        // mixin callback
        accountInitiated: function () {
            this.initCategory();
        },
        initCategory: function () {
            var cateId = this.$route.params.catId;
            if (cateId) {
                this.initialMenuCategory(cateId)
                    .then(() => {
                        this.hideLoading();
                        this.isActive = true;
                        this.isLoaded = true;
                    }).catch((err) => {
                        this.hideLoading();
                        this.isActive = true;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.errorApi(err, this.errorHandler);
                    });

            } else {
                this.isLoaded = true;
            }
        },
        //event
        clickBack: function () {
            this.$router.back();
        }
    }
}
</script>
